<div class="content">
  <div class="container-fluid" style="max-height: 860px;">

    <div class="row">
      <div
        class="col d-sm-flex align-items-center justify-content-between mb-4">

        <h1 class="dashboard-title">
          Extractor
        </h1>

        <button
          type="button"
          class="extractor-report-link"
          (click)="openExtractorReport()">

          <i class="fas fa-chart-bar"></i>
          Extractor Report

        </button>

      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12">

        <div class="card shadow-sm extractor-card p-4">
          <h5 class="mb-3">Upload Files</h5>

          <div
            class="upload-dropzone text-center"
            [class.dragover]="isDragOver"
            [class.disabled]="selectedDate"
            (click)="!selectedDate && fileInput.click()"
            (dragover)="!selectedDate && onDragOver($event)"
            (dragleave)="!selectedDate && onDragLeave($event)"
            (drop)="!selectedDate && onDrop($event)"
          >
            <input
              #fileInput
              type="file"
              multiple
              class="d-none"
              [disabled]="!!selectedDate"
              (change)="onFileSelected($event)"
            />

            <div class="upload-content">
              <div class="upload-icon mb-3">
                <i class="fa fa-cloud-upload"></i>
              </div>

              <h6 class="mb-2">Drag and drop files here</h6>
              <p class="text-muted mb-2">or click to browse from your computer</p>
              <small class="text-muted">Supports multiple files</small>
            </div>
          </div>

          <div class="selected-files mt-4" *ngIf="selectedFiles.length">
            <h6 class="mb-3">Selected Files</h6>

            <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
              <div class="file-left">
                <i class="fa fa-file-text-o file-icon"></i>
                <div>
                  <div class="file-name">{{ file.name }}</div>
                  <small class="text-muted">{{ formatFileSize(file.size) }}</small>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-sm btn-link text-danger"
                (click)="removeFile(i)"
              >
                Remove
              </button>
            </div>
          </div>

          <div class="mt-4">
            <div class="d-flex flex-wrap align-items-center gap-3 extractor-action-row">

              <div class="run-btn-wrapper">
                <label class="mb-1 d-block invisible">Run</label>
                <button
                  class="btn btn-primary px-4"
                  [disabled]="(!selectedFiles.length && !selectedDate) || !selectedOfficeId || !selectedInsurance || extractorRunning"
                  (click)="runExtractor()"
                >
                  {{ extractorRunning ? 'Extractor Running...' : 'Run Extractor' }}
                </button>
              </div>

              <div class="office-select-wrapper">
                <label class="mb-1 font-weight-600">Select Office</label>
                <select
                  class="form-control office-select"
                  [(ngModel)]="selectedOfficeId"
                  name="selectedOfficeId"
                >
                  <option [ngValue]="null">Select Office</option>
                  <option *ngFor="let office of OfficeType" [ngValue]="office.id">
                    {{  office.officeName || office.name }}
                  </option>
                </select>
              </div>

              <div class="insurance-select-wrapper">
              <label class="mb-1 font-weight-600">Select Insurance</label>
              <select
                class="form-control insurance-select"
                [(ngModel)]="selectedInsurance"
                name="selectedInsurance"
              >
                <option [ngValue]="null">Select Insurance</option>
                <option *ngFor="let ins of insuranceOptions" [ngValue]="ins.value">
                  {{ ins.name }}
                </option>
              </select>
              </div>

              <div class="date-select-wrapper">
              <label class="mb-1 font-weight-600">Select Date</label>
              <input
                type="date"
                class="form-control date-select"
                [(ngModel)]="selectedDate"
                name="selectedDate"
                [disabled]="selectedFiles.length > 0"
              />
              </div>

            </div>
          </div>

         <!-- Logs Card -->
<!-- Logs Card -->
        <div class="card shadow-sm extractor-card p-4 mt-1">

          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0">Extractor Logs</h5>

            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              (click)="clearLogs()"
              [disabled]="!extractorLogs.length && !extractorResult"
            >
              Clear
            </button>
          </div>

          <!-- Latest Run Summary -->
          <div
            class="extractor-result"
            *ngIf="extractorResult"
          >

            <div class="result-header">

              <div>
                <div class="result-title">
                  Latest Run
                </div>

                <small class="text-muted">
                  Extractor processing summary
                </small>
              </div>

              <button
                type="button"
                class="btn btn-sm btn-link result-toggle"
                (click)="showExtractorResult = !showExtractorResult"
              >
                {{ showExtractorResult ? 'Hide Details' : 'Show Details' }}
              </button>

            </div>


            <!-- Counts -->
            <div class="extractor-count-grid">

              <div class="extractor-count-item">
                <div class="count-label">
                  Total Accounts
                </div>

                <div class="count-value">
                  {{ extractorResult.totalAccountCount }}
                </div>
              </div>


              <div class="extractor-count-item valid">
                <div class="count-label">
                  Valid Accounts
                </div>

                <div class="count-value">
                  {{ extractorResult.validAccountCount }}
                </div>
              </div>


              <div
                class="extractor-count-item"
                [class.error]="extractorResult.validationErrorCount > 0"
              >
                <div class="count-label">
                  Validation Errors
                </div>

                <div class="count-value">
                  {{ extractorResult.validationErrorCount }}
                </div>
              </div>

            </div>


            <div *ngIf="showExtractorResult">

              <!-- Patients -->
              <div
                class="extractor-patients"
                *ngIf="extractorResult.patients?.length"
              >

                <div class="patient-section-header">
                  <span>
                    Patients Sent to Extractor
                  </span>

                  <span class="patient-count">
                    {{ extractorResult.patients.length }}
                  </span>
                </div>


                <div class="table-responsive extractor-patient-table-wrapper">

                  <table class="table extractor-patient-table">

                    <thead>
                      <tr>
                        <th>Patient Name</th>
                        <th>Member ID</th>
                        <th>DOB</th>
                      </tr>
                    </thead>


                    <tbody>

                      <tr
                        *ngFor="let patient of extractorResult.patients"
                      >

                        <td>
                          <div class="patient-name">
                            {{ getPatientName(patient) }}
                          </div>
                        </td>


                        <td>
                          <span class="member-id">
                            {{ patient.memberId || '-' }}
                          </span>
                        </td>


                        <td>
                          {{ getPatientDob(patient) }}
                        </td>

                      </tr>

                    </tbody>

                  </table>

                </div>

              </div>


              <!-- Validation Errors -->
              <div
                class="validation-error-section"
                *ngIf="extractorResult.validationErrors?.length"
              >

                <div class="validation-error-title">
                  <i class="fa fa-exclamation-triangle mr-2"></i>
                  Validation Errors
                </div>


                <div
                  class="validation-error-item"
                  *ngFor="let error of extractorResult.validationErrors"
                >
                  {{ error?.message || error }}
                </div>

              </div>

            </div>

          </div>


          <!-- Activity Logs -->
          <div
            class="activity-log-title"
            *ngIf="extractorLogs.length"
          >
            Activity
          </div>


          <div
            class="log-container"
            *ngIf="extractorLogs.length; else noLogs"
          >

            <div
              class="log-item"
              *ngFor="let log of extractorLogs"
              [ngClass]="{
                'log-start': log.type === 'start',
                'log-end': log.type === 'end',
                'log-info': log.type === 'info',
                'log-error': log.type === 'error'
              }"
            >

              <div class="log-time">
                {{ log.time }}
              </div>

              <div class="log-message">
                {{ log.message }}
              </div>

            </div>

          </div>


          <ng-template #noLogs>

            <div
              class="empty-log-state text-center"
              *ngIf="!extractorResult"
            >

              <div class="mb-2">
                No extractor logs yet
              </div>

              <small class="text-muted">
                Start the extractor to see activity logs here
              </small>

            </div>

          </ng-template>

        </div>

  </div>
</div>
